/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  updateWahaWebhook(inboxId, { status, events, webhookUrl }) {
    return axios.post(`${this.url}/${inboxId}/waha_webhook`, {
      status,
      events,
      webhook_url: webhookUrl,
    });
  }
}

export default new InboxHealthAPI();
